import { atom, useAtom } from "jotai";

export const isPositionsDrawerDraggedAtom = atom<boolean>(false);

export const useIsPositionsDrawerDragged = () => {
  const [isPositionsDrawerDragged, setIsPositionsDrawerDragged] = useAtom(
    isPositionsDrawerDraggedAtom,
  );

  return {
    isPositionsDrawerDragged,
    setIsPositionsDrawerDragged,
  };
};
